/* ═══════════════════════════════════════════════════════════
   MYVICTO — Accessory Collection Page: Add to Cart + Dynamic Pricing

   HOW TO USE:
   1. Upload this file to Assets folder in Shopify
   2. In theme.liquid, add before </body>:
      <script src="{{ 'myvicto-accessory-cart.js' | asset_url }}" defer></script>

   WHAT IT DOES:
   - Finds all myvicto-accessory-product sections on collection pages
   - Fetches product data (variants, prices) from Shopify API
   - Updates price when swatch is clicked
   - Adds to cart directly via Ajax (no redirect to product page)
   - Shows cart confirmation
   ═══════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  // Find all accessory product sections
  var sections = document.querySelectorAll('.myvicto-accessory-product-wrapper');
  if (!sections.length) return;

  sections.forEach(function(sectionEl) {
    var ctaBtn = sectionEl.querySelector('a[class*="mvap-cta"]');
    if (!ctaBtn) return;

    var productUrl = ctaBtn.getAttribute('href');
    if (!productUrl || productUrl === '#') return;

    // Extract product handle from URL
    var handle = productUrl.replace('/products/', '').replace(/\/$/, '').split('?')[0];
    if (!handle) return;

    // Fetch product data from Shopify
    fetch('/products/' + handle + '.js')
      .then(function(res) { return res.json(); })
      .then(function(product) {
        initAccessoryCart(sectionEl, product, ctaBtn);
      })
      .catch(function(err) {
        console.warn('myvicto-accessory-cart: could not fetch product', handle, err);
      });
  });

  function initAccessoryCart(sectionEl, product, ctaBtn) {
    var variants = product.variants;
    if (!variants || !variants.length) return;

    var selectedVariantIndex = 0;
    var priceEl = sectionEl.querySelector('[class*="mvap-price"]');
    var swatches = sectionEl.querySelectorAll('[data-mvap-swatch]');

    // Format price in the store's currency
    function formatPrice(priceInCents) {
      var amount = (priceInCents / 100).toFixed(2);
      // Use Shopify's money format if available
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        var symbol = getCurrencySymbol(window.Shopify.currency.active);
        return symbol + amount + ' ' + window.Shopify.currency.active;
      }
      return '$' + amount;
    }

    function getCurrencySymbol(code) {
      var symbols = {
        'USD': '$', 'EUR': '€', 'GBP': '£', 'CHF': 'CHF ', 'CAD': 'CA$',
        'AUD': 'A$', 'JPY': '¥', 'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr'
      };
      return symbols[code] || code + ' ';
    }

    // Update displayed price
    function updatePrice(variantIndex) {
      if (!priceEl || !variants[variantIndex]) return;
      var variant = variants[variantIndex];

      // Check if compare_at_price exists (sale)
      var priceHTML = formatPrice(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHTML = formatPrice(variant.price);
      }

      // Update price text (keep the small note if exists)
      var noteEl = priceEl.querySelector('small');
      var note = noteEl ? noteEl.outerHTML : '';
      priceEl.innerHTML = priceHTML + ' ' + note;
    }

    // Set initial price from first variant
    updatePrice(0);

    // Connect swatches to variants
    if (swatches.length) {
      swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
          var idx = parseInt(this.getAttribute('data-mvap-swatch'));
          if (idx < variants.length) {
            selectedVariantIndex = idx;
            updatePrice(idx);
          }
        });
      });
    }

    // Replace CTA link with Add to Cart button
    var addToCartBtn = document.createElement('button');
    addToCartBtn.className = ctaBtn.className;
    addToCartBtn.innerHTML = ctaBtn.innerHTML;
    addToCartBtn.setAttribute('type', 'button');
    addToCartBtn.setAttribute('data-mvap-add-to-cart', '');
    ctaBtn.parentNode.replaceChild(addToCartBtn, ctaBtn);

    // Add to Cart click handler
    addToCartBtn.addEventListener('click', function() {
      var variant = variants[selectedVariantIndex];
      if (!variant) return;

      // Disable button during request
      addToCartBtn.disabled = true;
      var originalText = addToCartBtn.innerHTML;
      addToCartBtn.innerHTML = 'Adding... <span class="mvap-cta-arrow">→</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: 1
          }]
        })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        // Success
        addToCartBtn.innerHTML = 'Added ✓ <span class="mvap-cta-arrow">→</span>';
        addToCartBtn.style.background = '#22c55e';
        addToCartBtn.style.color = '#fff';

        // Update cart count in header
        updateCartCount();

        // Reset button after 2 seconds
        setTimeout(function() {
          addToCartBtn.innerHTML = originalText;
          addToCartBtn.style.background = '';
          addToCartBtn.style.color = '';
          addToCartBtn.disabled = false;
        }, 2000);
      })
      .catch(function(err) {
        console.error('Add to cart failed:', err);
        addToCartBtn.innerHTML = 'Error — try again <span class="mvap-cta-arrow">→</span>';
        setTimeout(function() {
          addToCartBtn.innerHTML = originalText;
          addToCartBtn.disabled = false;
        }, 2000);
      });
    });
  }

  // Update cart count in header
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        // Update myvicto header cart count
        var countEls = document.querySelectorAll('.mvhd-cart-count');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
        });

        // If no count element exists but cart has items, create one
        if (!countEls.length && cart.item_count > 0) {
          var cartLinks = document.querySelectorAll('.mvhd-cart');
          cartLinks.forEach(function(link) {
            var span = document.createElement('span');
            span.className = 'mvhd-cart-count';
            span.textContent = cart.item_count;
            link.appendChild(span);
          });
        }
      });
  }

})();